import { useQuery } from '@tanstack/react-query';
import { fetchCurrentUser } from '../api/services/currentUserService';
import { queryKeys } from '../api/queryKeys';

// GET Current User
export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.currentUser.detail(),
    queryFn: fetchCurrentUser,
    staleTime: 1000 * 60 * 5, // 5 Minuten
    // Retry nur einmal bei Fehler (z.B. wenn Token abgelaufen)
    retry: 1,
  });
}
